import { GivelifyLabel, GivelifyMenu, GivelifySelect } from "@givelify/givelify-ui";
import { Grid, styled } from "@mui/material";

export const GridItem = styled(Grid)({
    padding: '3px 0 3px 16px',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 496,
});

export const GridMatchItem = styled(Grid)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: 202,
    height: 64,
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1, 0),
    },
}));

export const SelectEnvelope = styled(GivelifySelect)({
    '& input': {
        paddingLeft: 0,
        fontSize: 14,
    },
    '& fieldset': {
        border: 0,
    },
});

export const SelectEnvelopeMenu = styled(GivelifyMenu)({
    '& button': {
        border: 0,
        paddingLeft: 0,
    },
});

export const SelectFund = styled('div')({
    display: 'flex',
    flexDirection: 'column',
});

export const NoWrap = styled(GivelifyLabel)({
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});